<template>
<v-row no-gutters>
 
  <v-col cols="12" class="mt-12 d-flex justify-center">
    <v-card
    class="mx-auto"
   
  >
   <p class="text-center">
     <v-icon size="80">mdi-close-network</v-icon> 
    </p>
 
    <v-card-title>
     <v-alert
      color="red darken-3"
      dark
      icon="mdi-information-outline"
      border="right"
    >
      <span class="title font-weight-bold" style="color: white">
           {{ mensaje }}
          </span>
    </v-alert>
    </v-card-title>

  


     

  
  </v-card>
    
   
  </v-col>
</v-row>
  
</template>

<script>
export default {
  name: "msgError",
  props: {
    mensaje: String,
  },
};
</script>

<style>
</style>